import React from "react";
import { motion } from "framer-motion";

const Table = ({ columns, data, showSerialNumber = true, serialNumberOffset = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      style={{
        width: "100%",
        overflowX: "auto",
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr
            style={{
              backgroundColor: "#f9fafb",
              borderBottom: "2px solid #e5e7eb",
            }}
          >
            {/* S.No Column */}
            {showSerialNumber && (
              <th
                style={{
                  padding: "8px 12px",
                  textAlign: "center",
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#6b7280",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  width: "60px",
                }}
              >
                S.No
              </th>
            )}
            {columns.map((column, index) => (
              <th
                key={index}
                style={{
                  padding: "8px 12px",
                  textAlign: column.align || "left",
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#6b7280",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <motion.tr
              key={row.id || rowIndex}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: rowIndex * 0.05, duration: 0.3 }}
              style={{
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              {/* S.No Cell */}
              {showSerialNumber && (
                <td
                  style={{
                    padding: "10px 12px",
                    fontSize: "14px",
                    color: "#6b7280",
                    fontWeight: "500",
                    textAlign: "center",
                  }}
                >
                  {serialNumberOffset + rowIndex + 1}
                </td>
              )}
              {columns.map((column, colIndex) => (
                <td
                  key={colIndex}
                  style={{
                    padding: "10px 12px",
                    fontSize: "14px",
                    color: colIndex === 0 ? "#111827" : "#374151",
                    fontWeight: colIndex === 0 ? "500" : "normal",
                    textAlign: column.align || "left",
                  }}
                >
                  {column.render
                    ? column.render(row[column.accessor], row)
                    : row[column.accessor]}
                </td>
              ))}
            </motion.tr>
          ))}
        </tbody>
      </table>
    </motion.div>
  );
};

export default Table;
